import { Badge, Container, ListGroup } from "react-bootstrap";
import { Entry, LeagueData, Standing } from "../types/leagueData";

export function MOTM(props: {data: LeagueData}) {

  const leadStandings = props.data.standings.filter((v) => 
   v.position === 1 && v.phase_id !== 1 // Get first place and not the overall
  );

  leadStandings.sort((a, b) => b.phase_id - a.phase_id)

  const monthManager = (s: Standing) => {
    const player = props.data.entries.find((e) => e.id === s.entry_id);
    if (!player) {
      return <></>
    }

    return (
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start"
          key={s.phase_id}
        >
          <div className="ms-2 me-auto">
            <div className="fw-bold">{s.phase_name}</div>
            {player.player_name} - {player.name}
          </div>
          <Badge bg="primary" pill>
            {s.points}
          </Badge>
        </ListGroup.Item>
    )
  }

  return (
    <Container>
      <ListGroup as="ol">
        {leadStandings.map(monthManager)}
      </ListGroup>
    </Container>
  )

  
}
